<template>
  <popper trigger="clickToOpen" :options="{
      placement: 'auto',
      modifiers: { offset: { offset: '0,5px' } }
    }" @hide="hide">
    <div class="newSelect" slot="reference" @click.stop="open">
      <span class="txt">{{ placeholder }}</span>
    </div>
    <div :class="{ transferShow: isShow }">
      <div class="top">
        <el-checkbox
          v-for="(item, index) in list2"
          :checked="item?true:false"
          :label="item"
          :key="index"
          @change="
            (val) => {
              change2(val, index);
            }
          "
          >{{ item.teaName }}{{`-${item.teaId}`}}</el-checkbox
        >
      </div>
      <el-input
        class="ipt"
        size="small"
        v-model="input"
        placeholder="请输入内容"
      >
        <el-button
          slot="append"
          size="small"
          icon="el-icon-search"
          @click="search"
        ></el-button>
      </el-input>
      <div class="content">
        <el-checkbox
          v-for="(item, index) in list1"
          :label="item"
          :key="item.teaId"
          @change="change1(index)"
          >{{ item.teaName }}{{`-${item.teaId}`}}</el-checkbox
        >
      </div>
      
      <div class="btn">
        <div class="rado">
          <el-radio v-model="radio" label="1">仅包含</el-radio>
          <el-radio v-model="radio" label="2">不包含</el-radio>
        </div>
        <el-button size="mini" type="primary">确定</el-button>
      </div>
    </div>
  </popper>
</template>

<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
export default {
  name: "newSelect",
  components: {
    popper: Popper,
  },
  props: {
    placeholder: {
      type: String,
      default: () => {
        return "请选择";
      },
    },
    optionList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataObj:{}
  },
  watch: {
    optionList(newValue) {
      console.log(1);
      this.list1 = newValue;
    },
  },
  data() {
    return {
      isShow: false,
      input: "",
      list1: this.optionList,
      checkedList: [],
      list2: [],
      checkedList2: [],
      radio: "1",
    };
  },
  methods: {
    open() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    search() {
      this.$emit("search", this.input);
    },
    change1(v) {
      console.log(v);
      this.list2.push(this.list1[v]);
      this.list1.splice(v, 1);
      console.log(this.list1);
    },
    change2(v, index) {
      console.log(v, index);
      if (!v) {
        let data = this.list2.splice(index, 1);
        console.log(data);
        this.list1.push(data[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.newSelect {
  width: 220px;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  overflow: hidden;
  cursor: pointer;
  .txt {
    line-height: 40px;
    padding-left: 16px;
    color: #c3c5c9;
  }
}
.transferShow {
  width: 260px;
  max-height: 400px;
//   border: 1px solid red;
  background-color: #fff;
  z-index: 3000;
  opacity: 1;
  pointer-events: auto;
  position: relative;
//   box-shadow: 0 2px 12px 0 rgba(0 ,0 ,0 ,.1);
border: 1px solid #E4E7ED;
padding: 0 5px;
  .top {
    max-height: 120px;
    // border-bottom: 1px solid #c3c5c9;
    overflow-y: auto;
    padding: 2px;
    // .el-checkbox-group{
    //       width: 100%;
    .el-checkbox {
      width: 80%;
      padding-left: 6px;
    }
    //   }
  }
  .ipt {
    // margin-top: 2px;
    padding: 2px;
  }
  .content {
    width: 100%;
    max-height: 200px;
    // height: 200px;
    padding: 2px;
    overflow-y: auto;
    //   .el-checkbox-group{
    //       width: 100%;
    margin-bottom: 40px;
    .el-checkbox {
      width: 80%;
      padding-left: 6px;
    }
    //   }
  }
  .btn{
      height:40px;
      position: absolute;
      bottom: 0;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .rado{
          width: 60%;
          display: flex;
          .el-radio{
              margin-right: 10px;
          }
      }
  }
}
</style>
